
























































import { Vue, Component, Prop, Emit } from 'vue-property-decorator';

@Component({ components: {} })
export default class ReasonDetailLayerPopup extends Vue {
  @Prop({ required: true }) private isOpen = false
  @Prop({ required: true }) private type: 'EDIT' | 'DELETE' = 'EDIT';
  @Prop({ required: true }) private title = '';

  @Emit('confirmReasonDetailModal')
  private confirmReasonDetailModal() {
    const result = this.reasonDetail;
    this.reasonDetail = '';

    return result
  }

  @Emit('closeReasonDetailModal')
  private closeReasonDetailModal() {
    this.reasonDetail = '';

    return;
  }

  private reasonDetail = '';
}
